import CONFIG from '@/config';

export { sendEmail, sendSMS };

// Emails a signup link to a customer
function sendEmail(content) {
  return fetch(CONFIG.API + '/app_api/send_email/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'JWT ' + localStorage.getItem('RES_AUTH_TOKEN')
    },
    body: JSON.stringify(content)
  })
    .then(response => response.json())
    .catch(e => ({ error: e?.toString() }));
}

// SMS a singup link to a customer
function sendSMS(content) {
  return fetch(CONFIG.API + '/app_api/send_sms/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'JWT ' + localStorage.getItem('RES_AUTH_TOKEN')
    },
    body: JSON.stringify(content)
  })
    .then(response => response.json())
    .catch(e => ({ error: e?.toString() }));
}
